import PinwheelModal, { type PinwheelModalProps } from "@pinwheel/react-modal";
import { InstitutionFeatures } from "byzantine/src/types";

// support Atomic SSO and conditionally render respective SDK
// To-do https://linear.app/narmi/issue/CDB-878
type DirectDepositSSOProps = {
  type: InstitutionFeatures["direct_deposit"];
} & PinwheelModalProps;

const DirectDepositSSO = ({ ...props }: DirectDepositSSOProps) => (
  <PinwheelModal {...props} />
);

export default DirectDepositSSO;
